import React, { useState } from 'react';

const Settings = ({ settings, onSave, onClose }) => {
  const [startHour, setStartHour] = useState(settings.startHour);
  const [endHour, setEndHour] = useState(settings.endHour);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (startHour < endHour) {
      onSave({ startHour, endHour });
      onClose();
    }
  };

  const generateHourOptions = () => {
    const options = [];
    for (let i = 0; i <= 24; i++) {
      const displayHour = i === 24 ? '00' : i.toString().padStart(2, '0');
      const label = i === 24 ? '00:00 (Mesnatë)' : `${displayHour}:00`;
      options.push(
        <option key={i} value={i}>
          {label}
        </option>
      );
    }
    return options;
  };

  return (
    <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center p-4 z-50 animate-in fade-in duration-200">
      <div className="bg-white rounded-3xl p-8 w-full max-w-md shadow-2xl border border-gray-100 animate-in slide-in-from-bottom-4 duration-300">
        <div className="text-center mb-8">
          <div className="w-16 h-16 bg-gradient-to-r from-blue-500 to-purple-500 rounded-2xl flex items-center justify-center mx-auto mb-4">
            <span className="text-2xl">⚙️</span>
          </div>
          <h3 className="text-2xl font-bold text-gray-800">
            Cilësimet e Orëve të Punës
          </h3>
          <p className="text-gray-500 mt-2">Caktoni orët e punës së biznesit tuaj</p>
        </div>
        
        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label htmlFor="startHour" className="block text-sm font-semibold text-gray-700 mb-3">
              🌅 Ora e Fillimit
            </label>
            <select
              id="startHour"
              value={startHour}
              onChange={(e) => setStartHour(parseInt(e.target.value))}
              className="w-full p-4 border border-gray-200 rounded-xl focus:ring-2 focus:ring-purple-500 focus:border-transparent bg-gray-50 hover:bg-white transition-all duration-200 text-lg font-medium"
            >
              {generateHourOptions()}
            </select>
          </div>

          <div>
            <label htmlFor="endHour" className="block text-sm font-semibold text-gray-700 mb-3">
              🌇 Ora e Përfundimit
            </label>
            <select
              id="endHour"
              value={endHour}
              onChange={(e) => setEndHour(parseInt(e.target.value))}
              className="w-full p-4 border border-gray-200 rounded-xl focus:ring-2 focus:ring-purple-500 focus:border-transparent bg-gray-50 hover:bg-white transition-all duration-200 text-lg font-medium"
            >
              {generateHourOptions()}
            </select>
          </div>

          {startHour >= endHour && (
            <div className="p-4 bg-red-50 border border-red-200 rounded-xl flex items-center space-x-2">
              <span className="text-red-500">⚠️</span>
              <span className="text-red-600 text-sm font-medium">
                Ora e përfundimit duhet të jetë pas orës së fillimit
              </span>
            </div>
          )}

          <div className="flex space-x-4 pt-6">
            <button
              type="button"
              onClick={onClose}
              className="flex-1 py-4 px-6 border-2 border-gray-200 rounded-xl text-gray-600 hover:bg-gray-50 hover:border-gray-300 transition-all duration-200 font-semibold text-lg"
            >
              Anulo
            </button>
            <button
              type="submit"
              disabled={startHour >= endHour}
              className="flex-1 py-4 px-6 bg-gradient-to-r from-blue-600 to-purple-600 text-white rounded-xl hover:from-blue-700 hover:to-purple-700 transition-all duration-200 font-semibold text-lg shadow-lg hover:shadow-xl transform hover:scale-[1.02] disabled:bg-gray-400 disabled:cursor-not-allowed disabled:hover:scale-100 disabled:shadow-none"
            >
              💾 Ruaj
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Settings; 